import moment from 'moment-timezone'

import { NO_VALUE_PLACEHOLDER } from 'constants/common'
import type { UtcISOString } from 'types/datetime'
import type { EmissionEvent } from '../types/graphql'
import { formatNumberByKey } from './common'

export const hasAttribution = (emissionEvent?: EmissionEvent) =>
  !!emissionEvent?.source?.explanation ||
  emissionEvent?.source?.camSourceAssetReference?.asset?.properties?.name

export const formatDurationWithDayMinuteSecond = (
  startDate: UtcISOString,
  endDate?: UtcISOString | null
): string => {
  const end = moment(endDate ?? new Date())
  const duration = moment.duration(end.diff(moment(startDate)))

  const days = Math.trunc(duration.asDays())
  const minutes = duration.minutes() + duration.hours() * 60
  const seconds = duration.seconds()

  return [
    days > 0 ? `${days}d` : '',
    minutes > 0 ? `${minutes}m` : '',
    seconds > 0 ? `${seconds}s` : '',
  ]
    .filter(Boolean)
    .join(' ')
}

export const formatEmissionValue = ({
  value,
  isVolumeMode,
}: {
  value?: number | null
  isVolumeMode?: boolean
}) => {
  return formatNumberByKey(
    value,
    isVolumeMode ? 'emissionsVolume' : 'emissionsRate',
    NO_VALUE_PLACEHOLDER
  )
}
